import { durationAs } from '@eturi/date-util'
import { useT } from '@eturi/react-i18next'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { currentLang$ } from '../../compound-selectors/language'

export type AllowanceOpt = {
	readonly label: string
	readonly value: number
}

const MINUTE_OPTS = process.env.APP_ENV === 'dev' ? [3, 4, 5, 10, 15, 20, 25, 30] : [30]

export const useAllowanceOpts = () => {
	const [t] = useT('time_duration')
	const lang = useSelector(currentLang$)

	return useMemo(() => {
		const toAllowanceOpt = (label: string, secs: number): AllowanceOpt => ({ label, value: secs })

		return [
			// No allowance
			toAllowanceOpt(t('none'), 0),

			// Options as minutes. Only "30" shows up in prod. The rest are for QA testing
			...MINUTE_OPTS.map((mins) =>
				toAllowanceOpt(t('minutes', { value: mins }), durationAs(mins, 'm', 's')),
			),

			// Special singular "1 hour"
			toAllowanceOpt(t('1_hour'), durationAs(1, 'h', 's')),

			// Other hours
			...[1.5, 2, 2.5, 3, 4, 5, 6, 7, 8].map((hrs) =>
				toAllowanceOpt(t('hours', { value: hrs.toLocaleString(lang) }), durationAs(hrs, 'h', 's')),
			),

			// Special "All day"
			toAllowanceOpt(t('all_day'), durationAs(1, 'd', 's')),
		]
	}, [t])
}
